import {
  test,
  compose,
  isEmpty,
  length,
  equals,
  lte,
  complement,
  __,
  not,
} from 'ramda'

export const isNumeric = test(/^[0-9]+$/i)
export const isAlphanumeric = test(/^[a-z0-9]+$/i)
export const required = complement(isEmpty)
export const isMaxLength = (x) => compose(lte(__, x), length)
export const isLength = (x) => compose(equals(x), length)
export const truthy = complement(not)

export const releaseNumberRegex = /^[a-zA-Z0-9]{6}(-|\+)[a-zA-Z0-9]{2}$/
